export default "/_next/static/chunks/fonts/Merriweather-Bold-latin-7511a82c1c756e84532893dce37c7a9b.woff2";